import { COST_CALCULATOR_TRUSTED_HANDLER_EVENT } from './consts';

export const publishMessageToParentApp = (
  payload: string,
  eventName = COST_CALCULATOR_TRUSTED_HANDLER_EVENT
) => {
  window.parent?.postMessage?.(
    {
      name: eventName,
      payload: payload,
    },
    '*'
  );
};
